import React, { useState } from "react";
import { useTranslation } from "../i18n";
import AuthLanguageDropdown from "../Components/AuthLanguageDropdown";
import AuthLeftColumn from "../Components/AuthLeftColumn";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { vendorForgotPasswordAction } from "../actions/auth";
import { toogleErrorMessage } from "../actions/alertMessage";
import { isValidEmailAddress } from "../utils/formValidation";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector(
    (state) => Boolean(state.auth?.vendorForgotPasswordLoading),
  );
  const [email, setEmail] = useState("");
  const canSubmit = isValidEmailAddress(email) && !loading;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const normalizedEmail = email.trim();
    if (!normalizedEmail) {
      toogleErrorMessage("Please enter your email address.");
      return;
    }
    if (!e.currentTarget.checkValidity()) {
      toogleErrorMessage("Please enter a valid email address.");
      return;
    }
    await dispatch(vendorForgotPasswordAction({ email: normalizedEmail }));
  };

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <main className="admin-login-page admin-login-page--reference admin-login-page--auth-shared">
      <div className="container-fluid p-0">
        <div className="row g-0 admin-login-card">
          <AuthLeftColumn />
          <div className="col-lg-6 col-md-6 col-12 admin-login-right">
            <div className="admin-login-right-inner">
              <div className="admin-login-mobile-logo d-md-none">
                <img src="/assets/lualilogoblack.svg" alt={t("ui.luali.commodities")} />
                <AuthLanguageDropdown />
              </div>

              <div className="admin-login-form-content">
                <div className="admin-login-heading">
                  <h1>{t("ui.forgot.password")}</h1>

                  <p>{t("ui.enter.your.registered.email.address.and.we.ll.send.you.a.secure.password.reset.link")}</p>
                </div>

                <form className="admin-login-form" onSubmit={handleSubmit} noValidate>
                  <div className="admin-login-field">
                    <label htmlFor="forgot-email" className="form-label">{t("ui.email.address")}</label>
                    <div className="login-input-box">
                      <input
                        id="forgot-email"
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder={t("ui.vendor.example.com")}
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        autoComplete="email"
                        required
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="recent-view-all-btn w-100"
                    disabled={!canSubmit}
                  >
                    {loading ? t("ui.sending") : t("ui.sendResetLink")}
                  </button>
                </form>

                <div className="admin-login-bottom-text">
                  <span>{t("ui.remember.your.password")}</span>

                  <button type="button" onClick={handleBackToLogin}>{t("ui.back.to.login")}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ForgotPassword;
